/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.username_changes', [
      'admin.users.details.username_changes.service',
    ])
    .controller('UsernameChangesCtrl', UsernameChangesCtrl);

  /** @ngInject */
  function UsernameChangesCtrl($stateParams, UsernameChangesService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;

    UsernameChangesService.list(vm.userId).then(function(result) {
      for (var i = 0; i < result.results.length; i++) {
        result.results[i]['ts-m'] = new Date(result.results[i]['ts-m'] / 1000);
        result.results[i]['ts'] = new Date(result.results[i]['ts'] / 1000);
      }
      vm.items = result.results;
    });
  }

})();
